import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import '../CSS/login.css';
import { ENDPOINTS } from '../Helper/endpoints';
// import { useNavigate } from 'react-router-dom';

const UserLoginForm = ({ onLogin, setCurrentPage }) => {
  const [organizationCode, setOrganizationCode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // const navigate = useNavigate(); 
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!organizationCode || !email || !password) {
      Swal.fire({
        icon: 'warning',
        title: 'Input Error',
        text: 'Please fill in all fields.',
        customClass: {
          popup: 'small-swal-popup',
        },
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    setLoading(true);
    const url = ENDPOINTS.USER_LOGIN;

  //dummy data for testing
  // Dummy Login (frontend testing)
if (
  organizationCode === "ORG_5db2" &&
  email === "test@gmail.com" &&
  password === "1234"
) {
  const dummyData = {
    data: {
      user_info: {
        user_pid: "123",
        organizations_pid: "org123"
      }
    }
  };

  Cookies.set('userSession', JSON.stringify(dummyData), { expires: 7 });

  Swal.fire({
    icon: 'success',
    title: 'Login Successful (Dummy)',
    timer: 1500,
    showConfirmButton: false,
  });

  onLogin();
  return;   //  imp
}

axios
      .post(url, { organizations_code: organizationCode, email, password })
      .then((response) => {
        console.log('Response from API:', response.data);
        if (response.data.status) {
          console.log('Data to be stored in cookies:', response.data);
          Cookies.set('userSession', JSON.stringify(response.data), { expires: 7 });
          Swal.fire({
            icon: 'success',
            title: 'Login Successful',
            customClass: {
              popup: 'small-swal-popup',
            },
            // text: response.data.msg,
            timer: 1500,
            showConfirmButton: false,
          });
          onLogin();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: response.data.msg || 'Invalid credentials.',
            customClass: {
              popup: 'small-swal-popup',
            },
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
      .catch((error) => {
        console.error('Error from API:', error.response?.data || error.message);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || `An error occurred: ${error.message}`,
          customClass: {
            popup: 'small-swal-popup',
          },
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .finally(() => setLoading(false));
  };
  return (
    <div className="userlogin-container">
      <i className="bi bi-arrow-left-circle-fill back-icon"
        onClick={() => setCurrentPage('Home')}></i>
      <h2>User Login</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            className="form-control form-control-lg"
            id="organizationCode"
            value={organizationCode}
            placeholder="Enter Organization Code"
            onChange={(e) => setOrganizationCode(e.target.value)}
            required
            autoComplete="off"
          />
        </div>

        <div className="form-group">
          <input
            type="email"
            className="form-control form-control-lg"
            id="email"
            value={email}
            placeholder="Enter Email"
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="off"
          />
        </div>

        <div className="form-group">
          <input
            type="password"
            className="form-control form-control-lg"
            id="password"
            value={password}
            placeholder="Enter Password"
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
          />
        </div>
        <button type="submit" className="btn-login" disabled={loading}>
          {loading ? 'Login' : 'Login'}
        </button>
      </form>
    </div>
  );
};
export default UserLoginForm;
